// Registers the service worker (src/service-worker.js, written into builds as sw.js) so the app
// opens offline and can be installed, and offers a new version when one has been deployed.

import { flushSave, toast } from './store';

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  // Reload only when the user chose to: on a first visit the new worker takes over the page too,
  // and that shouldn't reload it.
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) location.reload();
  });
  const offer = (worker: ServiceWorker) =>
    toast('A new version of Relationships is ready.', 'info', {
      label: 'Reload',
      run: async () => {
        await flushSave();
        reloading = true;
        worker.postMessage('skip-waiting');
      },
    });
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('./sw.js');
      // Already waiting from an earlier visit (a first install has nothing to replace).
      if (reg.waiting && navigator.serviceWorker.controller) offer(reg.waiting);
      reg.addEventListener('updatefound', () => {
        const worker = reg.installing;
        worker?.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) offer(worker);
        });
      });
    } catch (e) {
      console.error(e);
    }
  });
}
